import React from 'react'
import { useTranslation } from 'react-i18next'
import { Card } from '../atoms/card'
import { css } from '@emotion/react'
import { Divider } from '../atoms/divider'
import { ListItem } from '../atoms/list-item'
import { LanguageType } from '@/i18n'
import { textOverflowStyle } from '@/styles/common'
import { usePickByLanguage } from '@/hooks/use-pick-by-language'
import { ReservationForSpace } from '@/features/space/space-search-reservation-slice'

interface ReservationSelectCardProps {
  reservation: ReservationForSpace
  selectLabel: React.ReactNode
}

export const AssignRoomSelectCard: React.FC<ReservationSelectCardProps> = ({ reservation, selectLabel }) => {
  const { t } = useTranslation()
  const pickByLanguage = usePickByLanguage()

  return (
    <Card cardCss={cardStyle}>
      {selectLabel}
      <Divider customCss={{ marginLeft: '-1.5rem', marginRight: '-1.5rem', marginTop: '1rem' }} />
      <div css={[listItemBlockStyle]}>
        <ListItem
          title={t('type of room')}
          text={pickByLanguage({
            [LanguageType.ja]: reservation.plan,
            [LanguageType.en]: reservation.planEn,
            [LanguageType.ko]: reservation.planEn,
            [LanguageType.zh]: reservation.planEn,
            [LanguageType.zhTw]: reservation.planEn,
          })}
        />

        <ListItem
          title={t('Room')}
          text={`${pickByLanguage({
            [LanguageType.ja]: reservation.reservationRoom.typeName,
            [LanguageType.en]: reservation.reservationRoom.typeNameEn,
            [LanguageType.ko]: reservation.reservationRoom.typeNameEn,
            [LanguageType.zh]: reservation.reservationRoom.typeNameEn,
            [LanguageType.zhTw]: reservation.reservationRoom.typeNameEn,
          })} / ${reservation.reservationRoom.roomNumber}`}
        />
        <ListItem
          title={t('Number of persons')}
          text={
            reservation.reservationRoom.pax &&
            `${reservation.reservationRoom.pax}${reservation.reservationRoom.pax === 1 ? t('Guest') : t('Guests')}`
          }
        />
        <ListItem title={t('reservation holder')} text={reservation.userName} />
        <ListItem title={t('confirmed guest')} text={reservation.guestName} />
      </div>
      <Divider customCss={{ marginLeft: '-1.5rem', marginRight: '-1.5rem', marginBottom: '1rem' }} />
      <p css={reservationItemStyle}>
        <span>{t('Reservation ID')}</span>
        <span css={textOverflowStyle}>{reservation.reservationId}</span>
      </p>
    </Card>
  )
}

const cardStyle = css({
  paddingTop: '1rem',
  paddingBottom: '1rem',
})

const reservationItemStyle = css({
  display: 'flex',
  fontSize: '12px',
  lineHeight: 1.5,
  span: {
    '&:first-of-type': {
      flex: '0 0 33%',
      marginRight: '2%',
    },
    '&:last-of-type': {
      flex: '0 0 65%',
    },
  },
})

const listItemBlockStyle = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  paddingTop: '1.5rem',
  paddingBottom: '1.5rem',
})
